export default __webpack_public_path__ + "static/media/dining.817a6301.jpeg";